import React, { useState } from "react";

import { FaDownload } from "react-icons/fa";
import {
  ModalHeader,
  ModalBody,
  Flex,
  Text,
  Icon,
  CheckboxGroup,
  FormLabel,
  Stack,
  Checkbox,
  SimpleGrid,
  Tooltip,
  useBreakpointValue,
} from "@chakra-ui/react";
import { CustomButton } from "../../../../../../components/CustomButton";
import CriancaService from "../../../../../../../main/services/CriancaService";
import {
  Permission,
  criancaFunc,
} from "../../../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../../../Context/AuthProvider";
import { IoHelpCircle } from "react-icons/io5";
import { PopoverGenero } from "../../../../../../components/PopoverGenero";

export const SituacaoJuridicaVisualizarModal = ({
  setIsVisual,
  onClose,
  selectedFiliacao,
  irmaosData,
}) => {
  const { roleKeycloack } = useAuthProvider();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [hintCompartilhar, setHintCompartilhar] = useState(false);

  const getAnexoGuia = (id, opcao) => {
    CriancaService.getAnexo(id, opcao)
      .then((res) => {
        if (opcao === "download") {
          const downloadUrl = res.config.url;
          window.open(downloadUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <ModalHeader
        p="0px"
        fontWeight={700}
        fontSize="14px"
        lineHeight="19.6px"
        color="#169499"
      >
        {`Visualizar Processo/Procedimento`.toUpperCase()}
      </ModalHeader>
      <ModalBody p="0px" mt="25px" minH={{ base: "0px", md: "200px" }} pl="1px">
        <Flex flexDirection="column" gap={2}>
          <Flex
            flexDirection="column"
            p={4}
            border={"solid 1px #b3b3b3"}
            rounded="md"
            gap={2}
          >
            <Text as="b">Nº do Processo/Procedimento: </Text>
            <Text>{selectedFiliacao.numeroProcesso} </Text>
            <Text as="b">Tipo: </Text>
            <Flex alignItems="center" gap={2} justifyContent="space-between">
              <Text>{selectedFiliacao.descricaoSituacaoJuridica}</Text>
              {selectedFiliacao.anexoPeticaoInicial && (
                <Flex alignItems="center" gap={2}>
                  <Text whiteSpace="nowrap" fontSize={"sm"}>
                    Baixar Petição
                  </Text>
                  <button
                    onClick={() =>
                      getAnexoGuia(
                        selectedFiliacao.anexoPeticaoInicial.id,
                        "download"
                      )
                    }
                  >
                    <Icon
                      aria-label="Download"
                      color="#006064"
                      as={FaDownload}
                      boxSize="18px"
                      _hover={{ cursor: "pointer" }}
                    />
                  </button>
                </Flex>
              )}
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            p={4}
            border={"solid 1px #b3b3b3"}
            rounded="md"
            gap={2}
          >
            <Text as="b">
              Há Decisão Liminar de Colocação em Família Substituta?
            </Text>
            <Flex alignItems="center" gap={2} justifyContent="space-between">
              <Text>
                {selectedFiliacao.liminarFamiliaSubstituta === "S"
                  ? "Sim "
                  : selectedFiliacao.liminarFamiliaSubstituta === "N"
                  ? "Não"
                  : "Não se Aplica"}
              </Text>
              {selectedFiliacao.anexoDecisaoLiminar && (
                <Flex alignItems="center" gap={2}>
                  <Text whiteSpace="nowrap" fontSize={"sm"}>
                    Baixar Decisão Liminar
                  </Text>
                  <button
                    onClick={() =>
                      getAnexoGuia(
                        selectedFiliacao.anexoDecisaoLiminar.id,
                        "download"
                      )
                    }
                  >
                    <Icon
                      aria-label="Download"
                      color="#006064"
                      as={FaDownload}
                      boxSize="18px"
                      _hover={{ cursor: "pointer" }}
                    />
                  </button>
                </Flex>
              )}
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            border={"solid 1px #b3b3b3"}
            rounded="md"
            p={4}
            gap={2}
          >
            <Text as="b">Sentença:</Text>
            <Flex alignItems="center" gap={2} justifyContent="space-between">
              <Text>
                {selectedFiliacao.sentenca === "S"
                  ? "Sim "
                  : selectedFiliacao.sentenca === "N"
                  ? "Não"
                  : "Não se Aplica"}
              </Text>
            </Flex>
            {selectedFiliacao.sentenca === "S" &&
              selectedFiliacao.idTipoSentenca && (
                <>
                  <Text as="b">Tipo de Sentença:</Text>

                  <Flex
                    alignItems="center"
                    gap={2}
                    justifyContent="space-between"
                  >
                    <Text>{selectedFiliacao.descricaoTipoSentenca}</Text>
                    {selectedFiliacao.anexoSentenca && (
                      <Flex alignItems="center" gap={2}>
                        <Text whiteSpace="nowrap" fontSize={"sm"}>
                          Baixar Sentença
                        </Text>
                        <button
                          onClick={() =>
                            getAnexoGuia(
                              selectedFiliacao.anexoSentenca.id,
                              "download"
                            )
                          }
                        >
                          <Icon
                            aria-label="Download"
                            color="#006064"
                            as={FaDownload}
                            boxSize="18px"
                            _hover={{ cursor: "pointer" }}
                          />
                        </button>
                      </Flex>
                    )}
                  </Flex>
                </>
              )}
          </Flex>
          <Flex
            flexDirection="column"
            p={4}
            border={"solid 1px #b3b3b3"}
            rounded="md"
            gap={2}
          >
            <Text as="b">Recurso:</Text>
            <Flex alignItems="center" gap={2} justifyContent="space-between">
              <Text>
                {selectedFiliacao.recurso === "S"
                  ? "Sim "
                  : selectedFiliacao.recurso === "N"
                  ? "Não"
                  : "Sem Informação"}
              </Text>
              {selectedFiliacao.anexoPecaRecursal && (
                <Flex alignItems="center" gap={2}>
                  <Text whiteSpace="nowrap" fontSize={"sm"}>
                    Baixar Recurso
                  </Text>
                  <button
                    onClick={() =>
                      getAnexoGuia(
                        selectedFiliacao.anexoPecaRecursal.id,
                        "download"
                      )
                    }
                  >
                    <Icon
                      aria-label="Download"
                      color="#006064"
                      as={FaDownload}
                      boxSize="18px"
                      _hover={{ cursor: "pointer" }}
                    />
                  </button>
                </Flex>
              )}
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            p={4}
            border={"solid 1px #b3b3b3"}
            rounded="md"
            gap={2}
          >
            <Text as="b">Trânsito em Julgado:</Text>
            <Flex alignItems="center" gap={2} justifyContent="space-between">
              <Text>
                {selectedFiliacao.transitoJulgado === "S"
                  ? "Sim "
                  : selectedFiliacao.transitoJulgado === "N"
                  ? "Não"
                  : "Não se Aplica"}
              </Text>
              {selectedFiliacao.anexoCertidaoTransitoJulgado && (
                <Flex alignItems="center" gap={2}>
                  <Text whiteSpace="nowrap" fontSize={"sm"}>
                    Baixar Certidão
                  </Text>
                  <button
                    onClick={() =>
                      getAnexoGuia(
                        selectedFiliacao.anexoCertidaoTransitoJulgado.id,
                        "download"
                      )
                    }
                  >
                    <Icon
                      aria-label="Download"
                      color="#006064"
                      as={FaDownload}
                      boxSize="18px"
                      _hover={{ cursor: "pointer" }}
                    />
                  </button>
                </Flex>
              )}
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            p={4}
            border={"solid 1px #b3b3b3"}
            rounded="md"
            gap={2}
          >
            <Text as="b">Informações Complementares:</Text>
            {selectedFiliacao.informacaoComplementar && (
              <Text>{selectedFiliacao.informacaoComplementar}</Text>
            )}
          </Flex>
          {irmaosData.options && irmaosData.options.length > 0 && (
            <Flex
              flexDirection="column"
              p={4}
              border={"solid 1px #b3b3b3"}
              rounded="md"
            >
              <Flex>
                <Text
                  fontWeight={700}
                  fontSize="14px"
                  lineHeight="21.6px"
                  color={"#169499"}
                >
                  {"Deseja Compartilhar Processo/Procedimento na Ficha do Irmão?".toUpperCase()}
                </Text>
                {isMobile ? (
                  <PopoverGenero
                    isOpen={hintCompartilhar}
                    setIsOpen={setHintCompartilhar}
                    flex={true}
                    handleClick={() => setHintCompartilhar(!hintCompartilhar)}
                    labelTextoGenero={
                      "Ao compartilhar um processo/procedimento com irmão(s), todas as informações serão importadas para ficha do(s) irmão(s) e as atualizações serão feitas de forma simultânea, ou seja, ao acessar qualquer uma das fichas e atualizar as informações sobre um processo/procedimento compartilhado, automaticamente essas informações também serão atualizadas na(s) ficha(s) do(s) irmão(s). Caso o processo/procedimento seja descompartilhado, as informações serão excluídas somente da ficha descompartilhada."
                    }
                  />
                ) : (
                  <Tooltip
                    label={
                      "Ao compartilhar um processo/procedimento com irmão(s), todas as informações serão importadas para ficha do(s) irmão(s) e as atualizações serão feitas de forma simultânea, ou seja, ao acessar qualquer uma das fichas e atualizar as informações sobre um processo/procedimento compartilhado, automaticamente essas informações também serão atualizadas na(s) ficha(s) do(s) irmão(s). Caso o processo/procedimento seja descompartilhado, as informações serão excluídas somente da ficha descompartilhada."
                    }
                    fontSize="md"
                    textAlign={"justify"}
                    maxW={"400px"}
                  >
                    <span className="hint-tooltip">
                      <Icon
                        aria-label="Aviso de pendente"
                        color="#6B6C71"
                        as={IoHelpCircle}
                        boxSize={{ base: "20px" }}
                      />
                    </span>
                  </Tooltip>
                )}
              </Flex>
              <Text mt={2}>
                {selectedFiliacao.compartilharProcesso === "S" ? "Sim" : "Não"}
              </Text>
              {selectedFiliacao.compartilharProcesso === "S" && (
                <CheckboxGroup
                  colorScheme="blue"
                  value={selectedFiliacao.irmaos
                    .filter((irmao) => irmao.compartilhado === "S")
                    .map((irmao) => irmao)}
                >
                  <FormLabel
                    py="2"
                    m={0}
                    mt={4}
                    px={6}
                    color={"gray.600"}
                    bgColor={"#DDEBEA"}
                    width="full"
                    maxWidth={{ base: "340px", md: "400px", xl: "500px" }}
                    minWidth={{ base: "340px", md: "400px", xl: "500px" }}
                    fontWeight="700"
                    fontSize="14px"
                    lineHeight="19.6px"
                    htmlFor={"irmaos"}
                  >
                    {"Irmão(s)*"}
                  </FormLabel>
                  <Stack
                    width="full"
                    maxWidth={{ base: "340px", md: "400px", xl: "500px" }}
                    minWidth={{ base: "340px", md: "400px", xl: "500px" }}
                    direction="column"
                  >
                    {selectedFiliacao.irmaos.map((value, index) => (
                      <Checkbox
                        key={index}
                        border="1px solid #b3b3b3"
                        value={value}
                        p={4}
                        name={"irmaos"}
                      >
                        {value.nomeIrmao}
                      </Checkbox>
                    ))}
                  </Stack>
                </CheckboxGroup>
              )}
            </Flex>
          )}

          <Flex justifyContent="end">
            <SimpleGrid
              mt="25px"
              columns={
                roleKeycloack && roleKeycloack.includes(criancaFunc.editarPP)
                  ? 2
                  : 1
              }
              spacing="15px"
              w={{
                base: "100%",
                lg:
                  roleKeycloack && roleKeycloack.includes(criancaFunc.editarPP)
                    ? "40%"
                    : "20%",
              }}
            >
              <CustomButton onClick={() => onClose()} label="Voltar" />
              <Permission
                roleKeycloack={roleKeycloack}
                func={criancaFunc.editarPP}
              >
                <CustomButton
                  onClick={(e) => {
                    setIsVisual(false);
                  }}
                  label="Editar"
                />
              </Permission>
            </SimpleGrid>
          </Flex>
        </Flex>
      </ModalBody>
    </>
  );
};
